import CookieNotice from './CookieNotice';
import { useConsentController } from './hooks';
import { useHideConsentUi } from './useHideConsentUi';

/**
 * Cookie banner / preferences UI. Hidden in embedded webviews: the host app
 * owns consent UX and GTM; checkout analytics go there via postMessage.
 * Also hidden on the cookie policy page so the policy is readable without the banner.
 */
const CookieConsentUI = () => {
  const { isLoaded, shouldHide } = useHideConsentUi();
  const {
    view,
    isOpen,
    showBack,
    showClose,
    categories,
    showNotice,
    showCustomize,
    dismiss,
    allowAll,
    declineAll,
    saveCustom,
  } = useConsentController();

  if (!isLoaded || shouldHide || !isOpen) return null;

  return (
    <CookieNotice
      open
      view={view}
      categories={categories}
      showBack={showBack}
      showClose={showClose}
      onAllowAll={allowAll}
      onDecline={declineAll}
      onCustomize={showCustomize}
      onBack={showNotice}
      onDismiss={dismiss}
      onSave={saveCustom}
    />
  );
};

export default CookieConsentUI;
